import React from 'react';
import { Outlet } from 'react-router-dom';
import styles from './AuthLayout.module.css';
import Card from '../../components/Card';

function AuthLayout() {
  return (
    <div className={styles.container}>
      <div className={styles.content}>
        <Card className={styles.card}>
          <div className={styles.logo}>
            <img src="/image_1_3.png" alt="DSC Platform" className={styles.logoImage} />
          </div>
          <Outlet />
        </Card>
      </div>
      <div className={styles.footer}>
        <span>© 2026 DSC Platform. All rights reserved.</span>
      </div>
    </div>
  );
}

export default AuthLayout;
